module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noResult":"We could not find a match...","placeholder":"Start typing here to search..."}}')
  delete Component.options._Ctor
}
